import styled from 'styled-components';
import { ComboboxOptionMixin } from '../../mixins/components/ComboboxOptionMixin';
import { ListboxOption } from '../ListboxOption/ListboxOption';
export var StyledComboboxOption = /*#__PURE__*/styled(ListboxOption).withConfig({
  displayName: "StyledComboboxOption",
  componentId: "c11n-8-111-1__sc-38afw7-0"
})(["", ""], ComboboxOptionMixin);